import { render } from "./PageWaitApprove.vue?vue&type=template&id=3c172e50&scoped=true"
import script from "./PageWaitApprove.vue?vue&type=script&lang=js"
export * from "./PageWaitApprove.vue?vue&type=script&lang=js"

import "./PageWaitApprove.vue?vue&type=style&index=0&id=3c172e50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c172e50"]])

export default __exports__